/* particulas.js — el ambiente por temporada.
   Lee window.KAWAII (que emite snippets/paleta-temporada.liquid): ninguna decisión
   de temporada se repite aquí. Se apaga solo si el visitante pidió menos movimiento,
   y baja la densidad en móvil (rendimiento = conversión). */
(function () {
  var K = window.KAWAII || {};
  var caja = document.getElementById('particulas');
  if (!caja) return;

  var menos = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cuantas = parseInt(K.particulas, 10) || 0;
  if (menos || cuantas <= 0) return;

  // En pantallas chicas, la mitad: 20 elementos animados en position:fixed castigan el móvil.
  if (window.innerWidth < 700) cuantas = Math.round(cuantas / 2);

  var emojis = (K.emojis && K.emojis.length) ? K.emojis : ['🌸', '☁️', '✨'];
  var imagenes = K.particulaImgs || [];      // los diseños propios ganan sobre los emoji
  var movimiento = K.movimiento || 'driftSide';

  // Las partículas NO arrancan durante la puerta ni la intro: entran cuando la tienda
  // ya se reveló. Si no, se ve "todo al mismo tiempo" y se pierde la secuencia.
  // Una sola vez, pase lo que pase: el aviso puede llegar DOS veces (la red de seguridad de
  // 12s de theme.liquid lo emite, y la intro también si termina después). Sin esta guarda se
  // insertarían 18-24 partículas en vez de 9-12.
  var yaConstruido = false;
  function construirUnaVez() {
    if (yaConstruido) return;
    yaConstruido = true;
    construir();
  }

  if (document.body.classList.contains('intro-corriendo')) {
    document.addEventListener('kawaii:listo', construirUnaVez);
  } else {
    construirUnaVez();
  }

  function construir() {
  var frag = document.createDocumentFragment();

  for (var i = 0; i < cuantas; i++) {
    var el;
    if (imagenes.length) {
      el = document.createElement('img');
      el.src = imagenes[i % imagenes.length]; el.alt = '';
      el.className = 'particula propia';
      el.style.width = (18 + Math.random() * 26) + 'px';
    } else {
      el = document.createElement('span');
      el.className = 'particula';
      el.textContent = emojis[i % emojis.length].trim();
      el.style.fontSize = (15 + Math.random() * 20) + 'px';
    }
    el.style.left = (Math.random() * 100) + 'vw';
    el.style.setProperty('--sway', (Math.random() * 60 - 30) + 'px');
    el.style.animation = movimiento + ' ' + (6 + Math.random() * 7) + 's linear infinite';
    el.style.animationDelay = (-Math.random() * 10) + 's';
    frag.appendChild(el);
  }
  caja.appendChild(frag);
  }
})();
